<template>
  <div class="bill-change-record tb" v-if="funcView.billChangeRecord_list">
    <div class="search-hd">
      <el-form
        :inline="true"
        @submit.native.prevent
      >
        <!-- 配置项 -->
        <el-form-item style="float: right">
          <custom-column
            :code="tableCode"
            v-model="tableColumn"
          ></custom-column>
        </el-form-item>
        <!-- 搜索项 -->
        <el-form-item style="float: right">
          <search-input
            v-model="formSearch.keyword"
            :placeholder="$t('fms_billChangeRecord.jshhtbh')"
            @fetch="onPageChange({ page: 1 })"
          ></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <switch-button :link="link"></switch-button>
        </el-form-item>
      </el-form>
    </div>
    <switch-container
      ref="container"
      @search="onPageChange({ page: 1 })"
      @clear="clearFilter()"
    >
      <el-form
        :inline="true"
        label-position="top"
      >
        <el-form-item :label="$t('fms_billChangeRecord.shen_qing_shi_jian')">
          <custom-date-picker
            style="width: 100%"
            v-model="formSearch.applyTime"
            type="daterange"
            align="right"
            value-format="YYYY-MM-DD HH:mm:ss"
          ></custom-date-picker>
        </el-form-item>

        <el-form-item :label="$t('fms_billChangeRecord.sqrssgs')">
          <el-input
            v-model="formSearch.applyOrgName"
            :clearable="true"
            :placeholder="$t('fms_billChangeRecord.sqrssgs')"
          ></el-input>
        </el-form-item>
      </el-form>
    </switch-container>
    <div class="table-bd">
      <custom-table
        height="100%"
        :data="tableList"
        :column="tableColumn"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['termNum', 'action']"
      >
        <template v-slot:termNum="scope">
          <div>{{ scope.row.termNum }}/{{ scope.row.totalTerm }}</div>
        </template>
        <template v-slot:action="scope">
          <span></span>
          <el-button
            v-if="funcView.billChangeRecord_detail"
            type="text"
            size="mini"
            @click="checkDetail(scope.row)"
          >{{ $t('fms_billChangeRecord.cha_kan_xiang_qing') }}</el-button>
        </template>

      </custom-table>
    </div>
    <div class="table-page">
      <custom-page
        :total="totalRows"
        :page="formSearch.pageNum"
        :size="formSearch.pageSize"
        @change="onPageChange"
      ></custom-page>
    </div>
    <approval-detail-dialog
      :workflowType="detailModel.workflowType"
      :bizId="detailModel.bizId"
      :row="detailModel.row"
      v-if="detailVisible"
      @close="detailVisible=false"
    ></approval-detail-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import resetFormSearchMixins from '@/mixins/reset_form_search_mixins';
import approvalDetailDialog from '@/components/approvalDetailDialog.vue';

export default {
  name: 'billChangeRecord',
  mixins: [resetFormSearchMixins],
  components: {
    approvalDetailDialog
  },
  data() {
    return {
      tableCode: 'bill_change_record',
      formSearch: {
        keyword: '',
        orderType: '',
        orderBy: '',
        pageSize: 50,
        pageNum: 1,
        applyOrgName: '',
        applyTime: '',
      },
      tableList: [],
      totalRows: null,
      link: null,
      detailModel: {},
      detailVisible: false,
    };
  },
  activated: function () {
    this.getTableList();
  },
  computed: {
  },
  watch: {
  },
  mounted() {
    this.resetForm = JSON.stringify(this.form);
    this.resetFormSearch = JSON.stringify(this.formSearch);

    this.getFuncView(null, () => {
      setTimeout(() => {
        this.link = this.$refs.container;
      }, 500);
    });

    this.getTableColumn();
  },
  methods: {
    // 获取产品列表
    getTableList: function () {
      this.$getJSON(apis.fmsChangeRecordsPage, this.formSearch).then((res) => {
        const list = res.data.records;
        this.tableList = list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getTableList();
    },
    checkDetail(row) {
      // this.detailModel = {
      //   changeType: row.workflowType,
      //   type: 'watch',
      //   changeId: row.bizId,
      //   row: row
      // };
      this.detailModel = {
        workflowType: row.workflowType,
        bizId: row.bizId,
        row
      };
      this.detailVisible = true;
    }
  },
};
</script>

<style lang="scss">
@import 'style/colors.scss';

.bill-change-record {
}
</style>
